"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CommentCount", {
  enumerable: true,
  get: function get() {
    return _CommentCount.CommentCount;
  }
});
Object.defineProperty(exports, "CommentEmbed", {
  enumerable: true,
  get: function get() {
    return _CommentEmbed.CommentEmbed;
  }
});
Object.defineProperty(exports, "DiscussionEmbed", {
  enumerable: true,
  get: function get() {
    return _DiscussionEmbed.DiscussionEmbed;
  }
});
exports["default"] = void 0;
var _CommentCount = require("./CommentCount");
var _CommentEmbed = require("./CommentEmbed");
var _DiscussionEmbed = require("./DiscussionEmbed");
var Disqus = {
  CommentCount: _CommentCount.CommentCount,
  CommentEmbed: _CommentEmbed.CommentEmbed,
  DiscussionEmbed: _DiscussionEmbed.DiscussionEmbed
};
var _default = Disqus;
exports["default"] = _default;